const firebaseConfig = {
    apiKey: "AIzaSyAIM-iKvtAmpNFotMsjk-8PZyso00RQntc",
    authDomain: "react-ema-john.firebaseapp.com",
    databaseURL: "https://react-ema-john.firebaseio.com",
    projectId: "react-ema-john",
    storageBucket: "react-ema-john.appspot.com",
    messagingSenderId: "90306050461",
    appId: "1:90306050461:web:843539be0b9072a4371774"
  };

  export default firebaseConfig;